export class GFilterViewIdRepo {
  static RegisterLicense = '1048';
  static AddressEdit = '60001'; //Address Edit form
  static ParcelEdit = '60002';
  static OwnerEdit = '60003';
  static ContactEdit = '60005';
  static AccountReferenceContactList = '60145';
  static ContactList = '60067';
  static ContactAddressList = '60134';
  static ContactLookUp = '60180'; //Application Contact Lookup form
  static ContactSelectFromAccountList = '60178';
  static ContactSelectFromProfessionals = '60195';
  static ContactAddressSearchList = '60179';
  static RegistrationContactAddressForm = '60143'; //Contact Address form
  static RegistrationContactForm = '60140'; //Contact Details form
  static AddReferenceContactForm = '60141'; //New Account form
  static ModifyReferenceContactForm = '60142'; //Modify Reference Contact Form
  static RegistrationContactAddressList = '60144';
  static UserRegistration = '60129'; //User Account Registration Details
  static ContactAddress = '60135'; //Application Contact Address
  static SearchByContact = '60065';
}

export class GFilterViewPermissionLevel {
  static UserRegistration = 'USERREGISTRATION';
  static PEOPLE = "People";
  static APO = "APO";
}

//Add GFilterViewIdRepo form ids in GFilterViewIdlist array
export const GFilterViewIdList = [
  '60001', //Address Edit form
  '60002', //Parcel Edit form
  '60003', //Owner Edit form
  '60145', //Account Reference Contact List
  '60143', //Registration Contact Address form
  '60140', //Registration Contact Details form
  '60144', //RegistrationContactAddressList
  '60129', //User Account Registration Details
];
